//src/components/common/DateInput.tsx
import React from 'react';
import './DateInput.css';

interface DateInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  purpose: string; // Texto que indica o propósito (ex.: "Entrega até")
  theme: 'dark' | 'light';
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  onChange,
  placeholder,
  purpose,
  theme,
}) => {
  return (
    <div className={`date-input-wrapper ${theme}`}>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="search-input date-input-field"
      />
      <span className="purpose-text">{purpose}</span>
    </div>
  );
};

export default DateInput;